import { ChangeEvent, useCallback, useEffect, useState } from 'react';

import { Input } from '@/core/components/Input';
import { Icon } from '@/core/components/Icons';
import { FocusItem } from '@/core/components/FocusItem/FocusItem';

import { AnalysesContainer } from './AnalysesList.styles';
import type { AnalysesListProps } from './AnalysesList.types';

export const AnalysesList = ({
  analyses,
  selectedAnalysisId,
  isAnalysisViewOpen,
  onOpenAnalysis,
}: AnalysesListProps) => {
  const [filteredAnalyses, setFilteredAnalyses] = useState(analyses);
  const [searchValue, setSearchValue] = useState('');

  const onSearch = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const searchText = event.target.value;

      setSearchValue(searchText);

      const filtered = analyses.filter(analysis =>
        analysis.title.toLowerCase().includes(searchText.toLowerCase())
      );

      setFilteredAnalyses(filtered);
    },
    [analyses]
  );

  useEffect(() => {
    setFilteredAnalyses(analyses);
  }, [analyses]);

  return (
    <AnalysesContainer>
      <Input
        placeholder="Search analyses"
        value={searchValue}
        onChange={onSearch}
        prefixIcon={<Icon name="Search" />}
      />
      {filteredAnalyses.map(analysis => (
        <FocusItem
          key={analysis.id}
          isSelected={selectedAnalysisId === analysis.id && isAnalysisViewOpen}
          name={analysis.title}
          onClick={() => onOpenAnalysis(analysis)}
          shouldHideEditButton
          useNormalCase
        />
      ))}
    </AnalysesContainer>
  );
};
